import { Typography } from "@mui/material"

export function VariantsCountCell({ count }) {
    return (
        <Typography variant="body2" sx={{ fontSize: 14, textAlign: "right" }}>
            {count}
        </Typography>
    )
}
